<template>
    <el-aside width="160px">
      <el-row>
        <el-col :span="24">
          <el-menu unique-opened :default-active="$route.path">
            <el-submenu v-for="x in menus" :index="x.id" :key="x.id">
              <template slot="title">
                <img :src="x.imgUrl" alt=""/>
                <span>{{x.name}}</span>
              </template>
              <el-menu-item :index="'/'+y.permission" v-for="y in x.children" :key="y.permission"><router-link :to="y.permission">{{y.name}}</router-link></el-menu-item>
            </el-submenu>
            <!--<el-submenu index="1">-->
              <!--<template slot="title">-->
                <!--<i class="el-icon-edit"></i>-->
                <!--<span>广告投放</span>-->
              <!--</template>-->
              <!--<el-menu-item index="/startPage"><router-link to="startPage">启动页</router-link></el-menu-item>-->
            <!--</el-submenu>-->
            <!--<el-submenu index="2">-->
              <!--<template slot="title">-->
                <!--<i class="el-icon-check"></i>-->
                <!--<span>广告审核</span>-->
              <!--</template>-->
              <!--<el-menu-item index="/ebus"><router-link to="ebus">东部公交</router-link></el-menu-item>-->
              <!--<el-menu-item index="/operator"><router-link to="operator">运营商</router-link></el-menu-item>-->
            <!--</el-submenu>-->
            <!--<el-submenu index="3">-->
              <!--<template slot="title">-->
                <!--<i class="el-icon-tickets"></i>-->
                <!--<span>基本信息</span>-->
              <!--</template>-->
              <!--<el-menu-item index="/customerList"><router-link to="customerList">客户信息维护</router-link></el-menu-item>-->
              <!--<el-menu-item index="/adverList"><router-link to="adverList">广告位维护</router-link></el-menu-item>-->
            <!--</el-submenu>-->
            <!--<el-submenu index="5">-->
              <!--<template slot="title">-->
                <!--<i class="el-icon-setting"></i>-->
                <!--<span>系统设置</span>-->
              <!--</template>-->
              <!--<el-menu-item index="/account"><router-link to="account">账号管理</router-link></el-menu-item>-->
              <!--<el-menu-item index="/role"><router-link to="role">角色设置</router-link></el-menu-item>-->
              <!--<el-menu-item index="/permiss"><router-link to="permiss">菜单设置</router-link></el-menu-item>-->
              <!--<el-menu-item index="/dics"><router-link to="dics">字典管理</router-link></el-menu-item>-->
            <!--</el-submenu>-->
          </el-menu>
        </el-col>
      </el-row>
    </el-aside>
</template>
<script>
  import Frame from '../components/layout.vue';
  import adPage from '../pages/adPut/start_page';
  export default {
    data (){
      return {
          menus:[]
      }
    },
    created(){
      let userInfo=JSON.parse(sessionStorage.getItem('userInfo'));
      this.menus=userInfo.sysMenus;
      let imgs=[
        {name:'广告投放',url:'../../../static/toufang.png'},
        {name:'广告审核',url:'../../../static/check.png'},
        {name:'基本信息',url:'../../../static/jibenxinxi.png'},
        {name:'系统设置',url:'../../../static/shezhi.png'}
      ]
      this.menus.forEach(function(item){
        imgs.forEach(function(v){
          if(item['name']==v['name']){
            item['imgUrl']=v['url'];
          }
        })
      })
    },
    methods : {
      hasPromiss(pro){
        let token=sessionStorage.getItem('token');
        if(token.indexOf(pro)!=-1){
          return true
        }else{
          return false
        }
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/menus.vue


// WEBPACK FOOTER //
// src/components/menus.vue